/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AttachmentVO } from '@well/attachment/domain';

export class ShipmentCommonsCmrDTO extends AttachmentVO {

  shipmentCommonsUuid: string | undefined = undefined;

  validFrom: string | undefined = undefined;

  validTo: string | undefined = undefined;

  description: string | undefined = undefined;

  constructor(attachmentVo: AttachmentVO) {
    super(
      attachmentVo.fileStoreAttachmentUuid,
      attachmentVo.fileName,
      attachmentVo.fileType,
      attachmentVo.fileSizeKB
    );
  }
}
